import { Component } from 'react';

// Bắt lỗi render của 1 màn: thay vì TRẮNG cả app, hiện thông báo + chi tiết lỗi để chẩn đoán.
// resetKey đổi (đổi trang) -> tự xoá lỗi để màn mới hiển thị bình thường.
export default class ErrorBoundary extends Component {
  state = { error: null, stack: '' };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('[UI crash]', error, info?.componentStack);
    this.setState({ stack: info?.componentStack || '' });
  }

  componentDidUpdate(prev) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null });
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="card" style={{ margin: 16 }}>
        <h3 style={{ color: 'var(--danger)', marginTop: 0 }}>⚠️ Màn hình gặp lỗi</h3>
        <p className="small muted">
          Đã có lỗi khi hiển thị màn này. Thử tải lại trang (Ctrl/Cmd + Shift + R). Nếu vẫn lỗi, chụp lại nội dung dưới đây gửi kỹ thuật.
        </p>
        <pre
          style={{
            whiteSpace: 'pre-wrap',
            fontSize: 12,
            background: 'var(--panel2)',
            padding: 10,
            borderRadius: 8,
            overflow: 'auto',
            maxHeight: 260,
          }}
        >
          {String(error?.stack || error?.message || error)}
          {this.state.stack ? `\n\n— Cây component —${this.state.stack}` : ''}
        </pre>
        <button className="btn sm" onClick={() => window.location.reload()}>
          🔄 Tải lại
        </button>
      </div>
    );
  }
}
